import { render, staticRenderFns } from "./kv-card.vue?vue&type=template&id=28944610"
import script from "./kv-card.vue?vue&type=script&lang=js"
export * from "./kv-card.vue?vue&type=script&lang=js"
import style0 from "./kv-card.vue?vue&type=style&index=0&id=28944610&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports